export enum EntityStoreKey {
  featureDiscovery = 'featureDiscovery',
}

export interface FeatureDiscoveryPayloadI {
  referralIntroUsed: boolean;
}
